// @generated by protoc-gen-connect-query v1.4.1 with parameter "target=ts"
// @generated from file no/jotta/openapi/people/v1/people.v1.proto (package no.jotta.openapi.people.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck
import { MethodKind } from "@bufbuild/protobuf";
import { GetFacesInPhotoRequest, GetFacesInPhotoResponse, GetMergeCandidatesRequest, GetMergeCandidatesResponse, GetPeopleRequest, GetPeopleResponse, GetPersonRequest, GetPersonResponse, GetPhotosWithPersonRequest, GetPhotosWithPersonResponse, MergePeopleRequest, MergePeopleResponse, PatchPersonRequest, PatchPersonResponse } from "./people.v1_pb.js";
import { PingRequest, PingResponse } from "../../ping_pb.js";
/**
 * @generated from rpc no.jotta.openapi.people.v1.PeopleService.GetPeople
 */
export const getPeople = {
    localName: "getPeople",
    name: "GetPeople",
    kind: MethodKind.Unary,
    I: GetPeopleRequest,
    O: GetPeopleResponse,
    service: {
        typeName: "no.jotta.openapi.people.v1.PeopleService"
    }
};
/**
 * @generated from rpc no.jotta.openapi.people.v1.PeopleService.GetPerson
 */
export const getPerson = {
    localName: "getPerson",
    name: "GetPerson",
    kind: MethodKind.Unary,
    I: GetPersonRequest,
    O: GetPersonResponse,
    service: {
        typeName: "no.jotta.openapi.people.v1.PeopleService"
    }
};
/**
 * @generated from rpc no.jotta.openapi.people.v1.PeopleService.GetFacesInPhoto
 */
export const getFacesInPhoto = {
    localName: "getFacesInPhoto",
    name: "GetFacesInPhoto",
    kind: MethodKind.Unary,
    I: GetFacesInPhotoRequest,
    O: GetFacesInPhotoResponse,
    service: {
        typeName: "no.jotta.openapi.people.v1.PeopleService"
    }
};
/**
 * @generated from rpc no.jotta.openapi.people.v1.PeopleService.GetPhotosWithPerson
 */
export const getPhotosWithPerson = {
    localName: "getPhotosWithPerson",
    name: "GetPhotosWithPerson",
    kind: MethodKind.Unary,
    I: GetPhotosWithPersonRequest,
    O: GetPhotosWithPersonResponse,
    service: {
        typeName: "no.jotta.openapi.people.v1.PeopleService"
    }
};
/**
 * @generated from rpc no.jotta.openapi.people.v1.PeopleService.PatchPerson
 */
export const patchPerson = {
    localName: "patchPerson",
    name: "PatchPerson",
    kind: MethodKind.Unary,
    I: PatchPersonRequest,
    O: PatchPersonResponse,
    service: {
        typeName: "no.jotta.openapi.people.v1.PeopleService"
    }
};
/**
 * @generated from rpc no.jotta.openapi.people.v1.PeopleService.GetMergeCandidates
 */
export const getMergeCandidates = {
    localName: "getMergeCandidates",
    name: "GetMergeCandidates",
    kind: MethodKind.Unary,
    I: GetMergeCandidatesRequest,
    O: GetMergeCandidatesResponse,
    service: {
        typeName: "no.jotta.openapi.people.v1.PeopleService"
    }
};
/**
 * @generated from rpc no.jotta.openapi.people.v1.PeopleService.MergePeople
 */
export const mergePeople = {
    localName: "mergePeople",
    name: "MergePeople",
    kind: MethodKind.Unary,
    I: MergePeopleRequest,
    O: MergePeopleResponse,
    service: {
        typeName: "no.jotta.openapi.people.v1.PeopleService"
    }
};
/**
 * Safe noop for testing purposes
 *
 * @generated from rpc no.jotta.openapi.people.v1.PeopleService.Ping
 */
export const ping = {
    localName: "ping",
    name: "Ping",
    kind: MethodKind.Unary,
    I: PingRequest,
    O: PingResponse,
    service: {
        typeName: "no.jotta.openapi.people.v1.PeopleService"
    }
};
